var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    style: {
      color: "#7F47FD"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.365h64v11.428H0V15.365Zm0 21.842h64v11.428H0V37.207Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSame);
export default __webpack_public_path__ + "static/media/same.ae17920432cb9c1baccec5cce1d8b4f1.svg";
export { ForwardRef as ReactComponent };